import React, {useEffect} from 'react'
import '../PageCss/NewsEvent.css'
import SideNavNewsEvents from '../components/SideNavNewsEvents'
import { Job } from '../components/Job'
import { useAappContext } from '../context/AppContext'

const Recruitment = () => {
  const{jobRecruitment,jobData, isLoadingJob}=useAappContext()

  useEffect(()=>{
    jobRecruitment('/jobrecruitment/')
    },[0])
if(isLoadingJob){
  <h>loading job .............</h>
}
  return (
    <section id="newevent" className='section-m1 section-p1'>
        <div className="newevent">

        <div id='page-title' className="title-yellow">
           <span>Job Placement</span>
          </div>
          
          <div className="newevent-content">

          <div className="jobs-container">
            {
              jobData.map((curElem)=>{
                return <Job key={curElem.id} {...curElem} />
              })
            }
          </div>  {/* newevent-content end */}
            

          </div>
        </div>
        <SideNavNewsEvents/>
      
    </section>
  )
}

export default Recruitment








// 